import {DataPoint} from '../../types';

/**
 * bridge data from -> to. close gaps on the right and left side of the series.
 *
 * if the array is empty, return zeroes from/to - we assume this means the series
 * had no data.
 *
 * @param from - earliest date to bridge
 * @param to - latest date to bridge
 * @param data - data to bridge
 * @param percentageData - default true - determines what to bridge with
 *  - if the series is percentage or score data, bridge with the nearest data node
 *  - otherwise if we're dealing with absolute values, assume that absence of data == 0
 */
export function bridge(
  from: Date,
  to: Date,
  data: DataPoint[],
  percentageData = true
): DataPoint[] {
  if (data.length === 0)
    return [
      {date: from, value: 0},
      {date: to, value: 0},
    ];

  const hasLeft = !!data.find(d => d.date.getTime() === from.getTime());
  const hasRight = !!data.find(d => d.date.getTime() === to.getTime());

  return [
    ...(!hasLeft ? [{date: from, value: percentageData ? data[0].value : 0}] : []),
    ...data,
    ...(!hasRight ? [{date: to, value: percentageData ? data[data.length - 1].value : 0}] : []),
  ];
}
